import BpkButton from '@skyscanner/backpack-web/bpk-component-button';
import BpkLargeAdultIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/adult';
import BpkInput from '@skyscanner/backpack-web/bpk-component-input';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n, type I18nShape } from '../../../../services/i18n';
import { HASH_GUESTS_ROOMS_CHILDREN } from '../../../../services/routes';
import FullScreenWrapper from '../../../FullScreenWrapper';
import { withHashRoutePortal } from '../../../HashRoute';
import RouteLink from '../../../RouteLink';
import GuestsRoomsChildren from '../GuestsRoomsChildren';
import getGuestsRoomsChildrenValue from '../getGuestsRoomsChildrenValue';

import type { Maybe } from '../../../../types';

import STYLES from './GuestsRoomsChildrenPortal.scss';

const FullScreenRoute = withHashRoutePortal(FullScreenWrapper);

const cls = cssModules(STYLES);

type Props = {
  i18n: I18nShape;
  adults: number;
  rooms: number;
  childrenAges: string[];
  className?: Maybe<string>;
  guestsRoomsFieldId: string;
  isApplyButtonDisabled?: boolean;
  onlyShowGuestsNumber?: boolean;
  onOpen: Function;
  onClose: Function;
  onGuestsRoomsChildrenChanged: Function;
};

const GuestsRoomsChildrenPortal = ({
  adults,
  childrenAges,
  className = undefined,
  guestsRoomsFieldId,
  i18n,
  isApplyButtonDisabled = false,
  onClose,
  onGuestsRoomsChildrenChanged,
  onOpen,
  onlyShowGuestsNumber = false,
  rooms,
}: Props) => (
  <div className={cls('GuestsRoomsChildrenPortal', className)}>
    <RouteLink
      href={HASH_GUESTS_ROOMS_CHILDREN}
      onClick={onOpen}
      render={(onClickLink: any) => (
        <div
          role="button"
          tabIndex={0}
          onKeyUp={() => {}}
          onClick={onClickLink}
          className={cls(
            onlyShowGuestsNumber && 'GuestsRoomsChildrenPortal__input',
          )}
          data-test-id={guestsRoomsFieldId}
          data-testid={guestsRoomsFieldId}
          id={guestsRoomsFieldId}
        >
          {onlyShowGuestsNumber ? (
            <>
              <BpkLargeAdultIcon
                className={cls('GuestsRoomsChildrenPortal__icon')}
              />
              <button type="button">
                {adults + (childrenAges ? childrenAges.length : 0)}
              </button>
            </>
          ) : (
            <BpkInput
              readOnly
              name={guestsRoomsFieldId}
              id={guestsRoomsFieldId}
              value={getGuestsRoomsChildrenValue({
                adults,
                rooms,
                childrenAges,
                translatePlural: i18n.translatePlural,
              })}
            />
          )}
        </div>
      )}
    />
    <FullScreenRoute
      hash={HASH_GUESTS_ROOMS_CHILDREN}
      headline={i18n.translate('HotelStay_label_guests_rooms')}
      renderFooter={(closeProtal: Function) => (
        <BpkButton
          disabled={isApplyButtonDisabled}
          onClick={() => {
            closeProtal();
            /**
             * On DV page, when onsubmit, a new history record will be pushed to browser history stack.
             * However, when close modal will triggle history.goBack, this method is asynthorous, avoiding
             * it triggled after new search cycle, so put onSubmit in setTimeout
             */
            setTimeout(() => {
              onClose();
            }, 0);
          }}
          className={cls('GuestsRoomsChildrenPortal__applyButton')}
        >
          {i18n.translate('Button_apply')}
        </BpkButton>
      )}
      footerClassName={cls('GuestsRoomsChildrenPortal__footer')}
      headerClassName={cls('GuestsRoomsChildrenPortal__header')}
      showCloseHeader
    >
      <GuestsRoomsChildren
        adults={adults}
        rooms={rooms}
        childrenAges={childrenAges}
        onGuestsRoomsChildrenChanged={onGuestsRoomsChildrenChanged}
      />
    </FullScreenRoute>
  </div>
);

export default withI18n(GuestsRoomsChildrenPortal);
